<template>
    <TipBox info :title="$t('tips.in_advance.title')">
        <p v-html="$t('tips.in_advance.description')"></p>
        <ul>
            <li>
                <b v-html="$t('settings.interval')"></b>
                <br><br>
                <span v-html="$t('tips.maximum_per_interval')"></span>
                <br>
                <br>
            </li>
            <li>
                <b v-html="$t('settings.orders_per_interval')"></b>
                <br><br>
                <span v-html="$t('tips.interval')"></span>
            </li>
        </ul>
    </TipBox>
</template>

<script>
    export default {
      name: "tipsInAdvance"
    }
</script>